(function () {
  /* ─── Wheel drag-to-rotate ─────────────────────────────────────────── */
  function initWheelDrag(root) {
    var wrap = root.querySelector('[data-cb-wheel-stage]');
    var img = root.querySelector('[data-cb-wheel-img]');
    if (!wrap || !img) return;

    var rot = 0;
    var dragging = false;
    var lastX = 0;

    function setRot(r) {
      rot = r;
      img.style.transform = 'rotateY(' + rot + 'deg)';
    }

    wrap.addEventListener('mousedown', function (e) {
      dragging = true;
      lastX = e.clientX;
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      setRot(rot + dx * 0.6);
    });
    window.addEventListener('mouseup', function () { dragging = false; });

    wrap.addEventListener('touchstart', function (e) {
      if (!e.touches.length) return;
      dragging = true;
      lastX = e.touches[0].clientX;
    }, { passive: true });
    window.addEventListener('touchmove', function (e) {
      if (!dragging || !e.touches.length) return;
      var x = e.touches[0].clientX;
      setRot(rot + (x - lastX) * 0.6);
      lastX = x;
    });
    window.addEventListener('touchend', function () { dragging = false; });
  }

  /* ─── Offset stepper ───────────────────────────────────────────────── */
  function initOffset(root) {
    var input = root.querySelector('[data-cb-offset-input]');
    if (!input) return;
    root.querySelectorAll('[data-cb-offset-delta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = parseInt(btn.getAttribute('data-cb-offset-delta'), 10) || 0;
        var v = parseInt(input.value, 10) || 0;
        input.value = String(v + d);
        updateSummary(root);
      });
    });
    input.addEventListener('input', function () { updateSummary(root); });
  }

  /* ─── Edit button scrolls back to left panel ───────────────────────── */
  function initSummaryEdit(root) {
    var edit = root.querySelector('[data-cb-summary-edit]');
    if (!edit) return;
    edit.addEventListener('click', function () {
      var panel = root.querySelector('.cb-panel.cb-config__left');
      if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ─── Finish display label (values = Liquid handleized names from configurator) ─ */
  function finishLabel(val) {
    if (!val) return '';
    return val.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  /* ─── Series label lookup ──────────────────────────────────────────── */
  var SERIES_LABELS = {
    'designer':    'Designer Series',
    'extreme':     'Extreme Series',
    'performance': 'Performance Series'
  };

  function seriesLabel(val) {
    return SERIES_LABELS[val] || val.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  /* ─── Read one radio group value ───────────────────────────────────── */
  function radioVal(root, name) {
    var checked = root.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : '';
  }

  /* ─── Read one select value ────────────────────────────────────────── */
  function selectText(root, id) {
    var el = root.querySelector('#' + id);
    if (!el) return '';
    if (el.value === 'other') {
      var other = root.querySelector('#' + id + '-other');
      return other && other.value ? other.value : '';
    }
    return el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : el.value;
  }

  /* ─── Build Summary updater ────────────────────────────────────────── */
  function updateSummary(root) {
    // Series
    var series = radioVal(root, 'wheel_series');
    setSummary(root, 'series', series ? seriesLabel(series) : '—');

    // Vehicle
    var make  = selectText(root, 'cb-make');
    var model = selectText(root, 'cb-model');
    var year  = selectText(root, 'cb-year');
    setSummary(root, 'vehicle', make + ' ' + model + ' ' + year);

    // Wheel size
    var diam  = radioVal(root, 'diameter');
    var width = radioVal(root, 'width');
    var sizeStr = (diam ? diam + '"' : '—') + (width ? ' × ' + width + '"' : '');
    setSummary(root, 'wheel-size', sizeStr || '—');

    // Offset
    var offsetInput = root.querySelector('[data-cb-offset-input]');
    var offsetVal = offsetInput ? parseInt(offsetInput.value, 10) : 0;
    var offsetStr = (offsetVal >= 0 ? '+' : '') + offsetVal + 'mm';
    setSummary(root, 'offset', offsetStr);

    // Finish
    var finish = radioVal(root, 'finish');
    var finishHuman = finish ? finishLabel(finish) : '';
    setSummary(root, 'finish', finishHuman || '—');
    var finishLabelEl = root.querySelector('[data-cb-finish-selected]');
    if (finishLabelEl) finishLabelEl.textContent = finishHuman ? ' ' + finishHuman : '';

    // Options
    var opts = [];
    if (root.querySelector('input[name="cnc_billet_logo"]:checked')) opts.push('CNC Billet Logo');
    setSummary(root, 'options', opts.length ? opts.join(', ') : 'None');
  }

  function setSummary(root, key, value) {
    var el = root.querySelector('[data-cb-summary="' + key + '"]');
    if (el) el.textContent = value;
  }

  /* ─── Other‑option toggle (select → text input) ───────────────────── */
  function initOtherInputs(root) {
    ['cb-make', 'cb-model', 'cb-year'].forEach(function (id) {
      var select = root.querySelector('#' + id);
      var other  = root.querySelector('#' + id + '-other');
      if (!select || !other) return;

      function toggle() {
        other.style.display = select.value === 'other' ? 'block' : 'none';
        if (select.value !== 'other') other.value = '';
        updateSummary(root);
      }

      select.addEventListener('change', toggle);
      toggle();
    });
  }

  /* ─── Series preview — swap wheel image, 3D model & hide 3D ────── */
  function initSeriesPreview(root) {
    var img      = root.querySelector('[data-cb-wheel-img]');
    var view3d   = root.querySelector('[data-cb-view-3d]');
    var toggle   = root.querySelector('[data-cb-view-toggle]');
    var model    = root.querySelector('[data-cb-model-viewer]');
    if (!img) return;

    var seriesRadios = root.querySelectorAll('input[name="wheel_series"]');

    function update() {
      var checked = root.querySelector('input[name="wheel_series"]:checked');
      if (!checked) return;
      var val = checked.value;
      var src = img.getAttribute('data-cb-src-' + val);
      if (src) img.src = src;
      img.alt = checked.parentElement.querySelector('.cb-series-card__name')
        ? checked.parentElement.querySelector('.cb-series-card__name').textContent
        : val;

      // Swap 3D model source
      if (model) {
        var modelSrc = model.getAttribute('data-cb-model-src-' + val);
        if (modelSrc) model.src = modelSrc;
        var iosSrc = model.getAttribute('data-cb-model-ios-' + val);
        if (iosSrc) model.setAttribute('ios-src', iosSrc);
      }

      // Reset to 2D view when series changes
      if (view3d && view3d.classList.contains('is-active')) {
        view3d.classList.remove('is-active');
        if (toggle) toggle.textContent = '3D';
      }
    }

    seriesRadios.forEach(function (r) { r.addEventListener('change', update); });
  }

  /* ─── 2D / 3D view toggle with lazy load ─────────────────────────── */
  function initViewToggle(root) {
    var img    = root.querySelector('[data-cb-wheel-img]');
    var view3d = root.querySelector('[data-cb-view-3d]');
    var toggle = root.querySelector('[data-cb-view-toggle]');
    var placeholder = root.querySelector('[data-cb-model-placeholder]');
    if (!img || !view3d || !toggle) return;

    var modelViewerCreated = false;

    function createModelViewer() {
      if (modelViewerCreated) return;
      modelViewerCreated = true;

      // Load model-viewer library
      if (!window.__modelViewerLoaded) {
        window.__modelViewerLoaded = true;
        var s = document.createElement('script');
        s.type = 'module';
        s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
        document.head.appendChild(s);
      }

      // Get current series
      var seriesRadio = root.querySelector('input[name="wheel_series"]:checked');
      var series = seriesRadio ? seriesRadio.value : 'designer';

      // Create model-viewer element
      var modelEl = document.createElement('model-viewer');
      modelEl.setAttribute('data-cb-model-viewer', '');
      modelEl.setAttribute('alt', '3D wheel model');
      modelEl.setAttribute('camera-controls', '');
      modelEl.setAttribute('auto-rotate', '');
      modelEl.setAttribute('ar', '');
      modelEl.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
      modelEl.style.width = '100%';
      modelEl.style.height = '100%';

      // Set initial sources from series
      var srcMap = {
        'designer': {
          glb: 'https://www.rrtforged.com/cdn/shop/3d/models/o/117c5221238c6a40/rrt_blade_custom_forged_wheel.glb?v=0',
          usdz: 'https://www.rrtforged.com/cdn/shop/3d/models/o/46cf395a9b4d6687/rrt_blade_custom_forged_wheel.usdz?v=0'
        },
        'extreme': {
          glb: 'https://www.rrtforged.com/cdn/shop/3d/models/o/945ec8bbde2d7a89/rs4.glb?v=0',
          usdz: 'https://www.rrtforged.com/cdn/shop/3d/models/o/41165be950c057de/rs4.usdz?v=0'
        },
        'performance': {
          glb: 'https://www.rrtforged.com/cdn/shop/3d/models/o/c5e0863ed2b5d020/XM.glb?v=0',
          usdz: 'https://www.rrtforged.com/cdn/shop/3d/models/o/25bf135e5008769e/XM.usdz?v=0'
        }
      };

      // Store data attributes for series switching
      modelEl.setAttribute('data-cb-model-src-designer', srcMap.designer.glb);
      modelEl.setAttribute('data-cb-model-ios-designer', srcMap.designer.usdz);
      modelEl.setAttribute('data-cb-model-src-extreme', srcMap.extreme.glb);
      modelEl.setAttribute('data-cb-model-ios-extreme', srcMap.extreme.usdz);
      modelEl.setAttribute('data-cb-model-src-performance', srcMap.performance.glb);
      modelEl.setAttribute('data-cb-model-ios-performance', srcMap.performance.usdz);

      var currentSrc = srcMap[series] || srcMap.designer;
      modelEl.setAttribute('src', currentSrc.glb);
      modelEl.setAttribute('ios-src', currentSrc.usdz);

      // Replace placeholder
      if (placeholder) {
        view3d.innerHTML = '';
        view3d.appendChild(modelEl);
      }
    }

    toggle.addEventListener('click', function () {
      var isActivating = !view3d.classList.contains('is-active');
      
      if (isActivating) {
        createModelViewer();
      }
      
      view3d.classList.toggle('is-active');
      toggle.textContent = view3d.classList.contains('is-active') ? '2D' : '3D';
    });
  }

  /* ─── Attach all change listeners ─────────────────────────────────── */
  function initLiveSummary(root) {
    // Selects (vehicle)
    ['cb-make', 'cb-model', 'cb-year'].forEach(function (id) {
      var el = root.querySelector('#' + id);
      if (el) el.addEventListener('change', function () { updateSummary(root); });
    });

    // Other text inputs
    root.querySelectorAll('[data-cb-other]').forEach(function (inp) {
      inp.addEventListener('input', function () { updateSummary(root); });
    });

    // All radio inputs
    root.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () { updateSummary(root); });
    });

    // All checkboxes
    root.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () { updateSummary(root); });
    });

    // Run once on load to populate from default checked state
    updateSummary(root);
  }

  /* ─── Diameter → width filter (real combinations only) ────────────── */
  function initDiameterWidthFilter(root) {
    var diams = root.querySelectorAll('input[name="diameter"]');
    var widths = root.querySelectorAll('[data-cb-width]');

    function filter() {
      var selected = root.querySelector('input[name="diameter"]:checked');
      if (!selected) return;
      var active = (',' + selected.value + ',').toLowerCase();
      var visible = [];
      widths.forEach(function (label) {
        var diamsAttr = label.getAttribute('data-diameters') || '';
        var match = (',' + diamsAttr.replace(/\s/g, '') + ',').toLowerCase().indexOf(active) !== -1;
        label.style.display = match ? '' : 'none';
        if (match) visible.push(label);
      });
      // If current selection is hidden, pick first visible or clear
      var checked = root.querySelector('input[name="width"]:checked');
      if (checked && checked.closest('[data-cb-width]').style.display === 'none') {
        checked.checked = false;
      }
      if (!root.querySelector('input[name="width"]:checked') && visible.length) {
        var firstRadio = visible[0].querySelector('input[type="radio"]');
        if (firstRadio) firstRadio.checked = true;
      }
      updateSummary(root);
    }

    diams.forEach(function (r) { r.addEventListener('change', filter); });
    // Run on boot so default state is correct
    filter();
  }

  /* ─── Boot ─────────────────────────────────────────────────────────── */
  function boot() {
    document.querySelectorAll('[data-custom-build-root]').forEach(function (root) {
      initWheelDrag(root);
      initOffset(root);
      initSummaryEdit(root);
      initOtherInputs(root);
      initSeriesPreview(root);
      initViewToggle(root);
      initLiveSummary(root);
      initDiameterWidthFilter(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
